export function date(val) {
    const date = new Date(val)
    return date.toLocaleDateString("en-GB", {
        year: "numeric",
        month: "short",
        day: "numeric",
    })
}

export function dateTime(val) {
    const date = new Date(val)
    return date.toLocaleDateString("en-GB", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: '2-digit',
        minute: '2-digit'
    })
}

export function isInPast(val) {
    const date = new Date(val)
    const now = new Date()
    return date.getTime() < now.getTime() 
}